// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportDetailLink_report-detail-link__vnb1F {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  border-radius: 6px;
  padding: 5px 12px;
  line-height: 1.4;
  white-space: nowrap;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}
.ReportDetailLink_report-detail-link__vnb1F .ReportDetailLink_icon__-w2IK {
  flex-shrink: 0;
}
.ReportDetailLink_report-detail-link__vnb1F .ReportDetailLink_text__bafkG {
  font-style: normal;
}
.ReportDetailLink_report-detail-link__vnb1F .ReportDetailLink_arrow__aK\\+AC {
  flex-shrink: 0;
  transition: transform 0.2s ease-in-out;
}
.ReportDetailLink_report-detail-link__vnb1F:hover .ReportDetailLink_arrow__aK\\+AC {
  transform: translate(1.5px, -1.5px);
}
.ReportDetailLink_report-detail-link__vnb1F.ReportDetailLink_variant-default__OPgvP {
  background-color: rgba(26, 86, 219, 0.08);
  color: #1a56db;
  border: 1px solid rgba(26, 86, 219, 0.22);
}
.ReportDetailLink_report-detail-link__vnb1F.ReportDetailLink_variant-default__OPgvP:hover {
  background-color: #1a56db;
  color: #ffffff;
  border-color: #1a56db;
  box-shadow: 0 2px 8px rgba(26, 86, 219, 0.25);
}
.ReportDetailLink_report-detail-link__vnb1F.ReportDetailLink_variant-light__JfTK- {
  background-color: rgba(255, 255, 255, 0.16);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.32);
  backdrop-filter: blur(4px);
}
.ReportDetailLink_report-detail-link__vnb1F.ReportDetailLink_variant-light__JfTK-:hover {
  background-color: #ffffff;
  color: #1a56db;
  border-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.ReportDetailLink_report-detail-link__vnb1F.ReportDetailLink_variant-outline__mSAYW {
  background-color: transparent;
  color: #4b5563;
  border: 1px solid #d1d5db;
}
.ReportDetailLink_report-detail-link__vnb1F.ReportDetailLink_variant-outline__mSAYW:hover {
  background-color: #f3f4f6;
  color: #111827;
  border-color: #9ca3af;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/ReportDetailLink/ReportDetailLink.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;AACF;AACE;EACE,cAAA;AACJ;AAEE;EACE,kBAAA;AAAJ;AAGE;EACE,cAAA;EACA,sCAAA;AADJ;AAKI;EACE,mCAAA;AAHN;AAQE;EACE,yCAAA;EACA,cAAA;EACA,yCAAA;AANJ;AAQI;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,6CAAA;AANN;AAWE;EACE,2CAAA;EACA,cAAA;EACA,2CAAA;EACA,0BAAA;AATJ;AAWI;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,yCAAA;AATN;AAcE;EACE,6BAAA;EACA,cAAA;EACA,yBAAA;AAZJ;AAcI;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;AAZN","sourcesContent":[".report-detail-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  text-decoration: none;\n  border-radius: 6px;\n  padding: 5px 12px;\n  line-height: 1.4;\n  white-space: nowrap;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n\n  .icon {\n    flex-shrink: 0;\n  }\n\n  .text {\n    font-style: normal;\n  }\n\n  .arrow {\n    flex-shrink: 0;\n    transition: transform 0.2s ease-in-out;\n  }\n\n  &:hover {\n    .arrow {\n      transform: translate(1.5px, -1.5px);\n    }\n  }\n\n  // Default variant: for light backgrounds (Institution & Unit detail pages)\n  &.variant-default {\n    background-color: rgba(26, 86, 219, 0.08);\n    color: #1a56db;\n    border: 1px solid rgba(26, 86, 219, 0.22);\n\n    &:hover {\n      background-color: #1a56db;\n      color: #ffffff;\n      border-color: #1a56db;\n      box-shadow: 0 2px 8px rgba(26, 86, 219, 0.25);\n    }\n  }\n\n  // Light variant: for dark backgrounds\n  &.variant-light {\n    background-color: rgba(255, 255, 255, 0.16);\n    color: #ffffff;\n    border: 1px solid rgba(255, 255, 255, 0.32);\n    backdrop-filter: blur(4px);\n\n    &:hover {\n      background-color: #ffffff;\n      color: #1a56db;\n      border-color: #ffffff;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    }\n  }\n\n  // Outline variant: subtle bordered button\n  &.variant-outline {\n    background-color: transparent;\n    color: #4b5563;\n    border: 1px solid #d1d5db;\n\n    &:hover {\n      background-color: #f3f4f6;\n      color: #111827;\n      border-color: #9ca3af;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"report-detail-link": `ReportDetailLink_report-detail-link__vnb1F`,
	"icon": `ReportDetailLink_icon__-w2IK`,
	"text": `ReportDetailLink_text__bafkG`,
	"arrow": `ReportDetailLink_arrow__aK+AC`,
	"variant-default": `ReportDetailLink_variant-default__OPgvP`,
	"variant-light": `ReportDetailLink_variant-light__JfTK-`,
	"variant-outline": `ReportDetailLink_variant-outline__mSAYW`
};
export default ___CSS_LOADER_EXPORT___;
